import React from 'react'
import { Icon } from '../../atoms/Icon'
import { PlatformsCardProps } from './PlatformsCard.types'
import {
  StyledPlatformsCard,
  PlatformsHeader,
  PlatformsTitle,
  PlatformsList,
  PlatformItem,
  PlatformIcon,
  PlatformInfo,
  PlatformName,
  PlatformStatus,
  StatusDot,
  StatusText,
  PlatformLink,
  PlatformInitials,
} from './PlatformsCard.styles'

export const PlatformsCard: React.FC<PlatformsCardProps> = ({
  title,
  platforms,
  onPlatformClick,
  className,
}) => {
  const getInitials = (name: string): string => {
    const words = name.trim().split(/\s+/)
    if (words.length >= 2) {
      // Take first letter of first two words
      return (words[0][0] + words[1][0]).toUpperCase()
    } else if (name.length >= 2) {
      // If single word, take first two letters
      return name.substring(0, 2).toUpperCase()
    } else {
      // Fallback to just the first letter doubled
      return (name[0] || 'P').toUpperCase().repeat(2)
    }
  }

  return (
    <StyledPlatformsCard className={className}>
      <PlatformsHeader>
        <PlatformsTitle>{title}</PlatformsTitle>
      </PlatformsHeader>

      <PlatformsList>
        {platforms.map((platform, index) => (
          <PlatformItem
            key={index}
            href={
              platform.active !== false && platform.url ? platform.url : '#'
            }
            target="_blank"
            rel="noopener noreferrer"
            $isDisabled={platform.active === false}
            onClick={
              platform.active === false
                ? (e) => e.preventDefault()
                : !platform.url && onPlatformClick
                  ? (e) => {
                      e.preventDefault()
                      onPlatformClick(platform)
                    }
                  : !platform.url
                    ? (e) => e.preventDefault()
                    : undefined
            }
          >
            <PlatformIcon>
              {platform.iconUrl ? (
                <img src={platform.iconUrl} alt={platform.name} />
              ) : platform.icon ? (
                <Icon name={platform.icon} size="small" />
              ) : (
                <PlatformInitials>
                  {getInitials(platform.name)}
                </PlatformInitials>
              )}
            </PlatformIcon>
            <PlatformInfo>
              <PlatformName>{platform.name}</PlatformName>
              <PlatformStatus>
                <StatusDot $active={platform.active !== false} />
                <StatusText>
                  {platform.active !== false ? 'Active' : 'Inactive'}
                </StatusText>
              </PlatformStatus>
            </PlatformInfo>
            {platform.url && platform.active !== false && (
              <PlatformLink>
                <Icon name="arrow-right" size="small" />
              </PlatformLink>
            )}
          </PlatformItem>
        ))}
      </PlatformsList>
    </StyledPlatformsCard>
  )
}
